function downloadPedidoJson(pedido, fileName) {
  const blob = new Blob([JSON.stringify(pedido, null, 2)], { type: "application/json" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName || `pedido-${pedido?.idPedidoOpticlick || pedido?.id || "conecta"}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export { downloadPedidoJson };
